import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initAnalytics } from "./lib/analytics";
import { initSentry } from "./lib/monitoring/sentry";
import { installClickToDismiss } from "./lib/farmlyToast";

initSentry();
initAnalytics();
installClickToDismiss();

createRoot(document.getElementById("root")!).render(<App />);
